/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const userPostalAddressInputAddressLine1Max = 200;

export const userPostalAddressInputAddressLine2Max = 200;

export const userPostalAddressInputPostcodeRegExp = new RegExp('^\\d{4}$');
export const userPostalAddressInputSuburbMax = 100;

export const UserPostalAddressInput = zod
  .object({
    addressLine1: zod.string().min(1).max(userPostalAddressInputAddressLine1Max),
    addressLine2: zod.string().max(userPostalAddressInputAddressLine2Max).optional(),
    country: zod.enum(['AU']).optional(),
    postcode: zod.string().regex(userPostalAddressInputPostcodeRegExp),
    state: zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
    suburb: zod.string().min(1).max(userPostalAddressInputSuburbMax),
  })
  .describe(
    'Postal address, replacing the stored one part by part. Street line, suburb, state and postcode are required together; `addressLine2` is optional and `country` defaults to AU. Australian addresses only.',
  );

export type UserPostalAddressInput = zod.input<typeof UserPostalAddressInput>;
export type UserPostalAddressInputOutput = zod.output<typeof UserPostalAddressInput>;
